module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.checkSubdomain) ? _c('div', [_c('login-with-subdomain')], 1) : _c('div', [_c('login-without-subdomain')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38e87afe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/auth/Main.vue
// module id = 755
// module chunks = 1